import { FileArrowUpSolid } from '@allocab/allocab-icons';

import { t } from '../services/translation/translation';

type Props = {
  onChange: (_list: FileList | null) => void;
};

export const DragAndDropInput = ({ onChange }: Props) => {
  return (
    <div className="flex w-full h-full">
      <label
        htmlFor="dropzone-file"
        className="flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
      >
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
          <FileArrowUpSolid width={20} height={20} className="fill-current mb-2" />
          <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
            <span className="font-semibold">{t('common.click-to-upload')}</span> {t('common.or-drag-and-drop')}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">PNG, JPG, PDF</p>
        </div>
        <input
          id="dropzone-file"
          type="file"
          className="hidden"
          accept="image/*, application/pdf"
          onChange={e => onChange(e.currentTarget.files)}
        />
      </label>
    </div>
  );
};
